import React, { FC, useEffect } from 'react';
import { Link } from 'gatsby';
import { clearLocalStorage } from '../../utils';

import { BranchLogo, ProviderInfo } from './styled';
import { vars } from '../../reactive';
import { setFormPage } from '../../reactive/actions';
import { FORM_PAGES } from '../Form/types';
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { GetAllPets } from '../../utils/queries';
import { logout } from '../../utils/auth';
import { Auth, AuthText, SignOutButton } from '../Footer/styled';
import { Line } from '../Shared/Shared';
import { RequireAtLeastOne } from '../../utils';

type HeaderProps = RequireAtLeastOne<
  {
    provider: Record<string, any>;
    branch: Record<string, any> | null;
  },
  'provider' | 'branch'
>;

const Header: FC<HeaderProps> = ({ provider, branch }) => {
  const currentBranch = provider?.branches?.[0] || branch;
  const isLoggedIn = useReactiveVar(vars.isLoggedIn);
  const [getUserProfile, { data: userProfile, loading }] = useLazyQuery(GetAllPets);

  useEffect(() => {
    if (isLoggedIn) {
      getUserProfile();
    }
  }, [isLoggedIn]);
  return (
    <ProviderInfo branchPrimaryColor={currentBranch?.colors?.primary}>
      <Link to="../" onClick={() => clearLocalStorage()}>
        <BranchLogo src={currentBranch?.photos?.logo} alt={currentBranch?.name || provider?.name || 'brand name'} />
      </Link>
      {!isLoggedIn && (
        <Auth>
          <SignOutButton
            onClick={() => {
              setFormPage(FORM_PAGES.CREATE_ACCOUNT_EMAIL);
              vars.selectedProduct(null);
            }}
            style={{ textDecoration: 'none', fontSize: '12px' }}
          >
            Member Login
          </SignOutButton>
        </Auth>
      )}
      {isLoggedIn && userProfile?.getProfile && (
        <Auth>
          <AuthText style={{ fontSize: '12px' }}>{userProfile?.getProfile.name} |</AuthText>

          <SignOutButton
            onClick={() => {
              logout();
            }}
            style={{ textDecoration: 'none', fontSize: '12px' }}
          >
            Sign Out
          </SignOutButton>
          <Line />
        </Auth>
      )}
    </ProviderInfo>
  );
};
export default Header;
